var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"moderated-operation-state",class:`moderated-operation-state--${_vm.display}`,style:({
    '--moderated-operation-state-color': _vm.stepperColor,
    '--moderated-operation-state-bg': _vm.stepperBgColor,
    '--moderated-operation-state-border': _vm.stepperBorderColor
  })},[(_vm.showStepper)?_c('span',{staticClass:"moderated-operation-state__stepper",attrs:{"aria-hidden":"true"}},_vm._l((_vm.totalSegments),function(segment){return _c('span',{key:segment,staticClass:"moderated-operation-state__segment",class:{
        'moderated-operation-state__segment--active':
          segment <= _vm.progressValue
      }})}),0):_vm._e(),(_vm.showText)?_c('span',{staticClass:"moderated-operation-state__text",style:({ color: _vm.textColor })},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }